/* Heizsolar24 Theme – Verhalten.
   Kein Framework. Alle Daten kommen live aus Shopify (Cart AJAX API, Predictive Search, Section Rendering).
   Konfiguration aus window.HS24 (layout/theme.liquid). */
(() => {
  'use strict';
  const HS = window.HS24 || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' }, currency: 'EUR' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  /* Geldbeträge im Format des Shops (Einstellungen → Allgemein → Währungsformat), wie Liquid | money.
     Ohne hinterlegtes Format: deutsches Standardformat. */
  const MONEY_FORMAT = HS.moneyFormat || '{{amount_with_comma_separator}} €';
  function money(cents, noDecimals) {
    const v = (Number(cents) || 0) / 100;
    const fmt = (dec, ts, ds) => {
      const parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    };
    const map = {
      amount: () => fmt(noDecimals ? 0 : 2, ',', '.'),
      amount_no_decimals: () => fmt(0, ',', '.'),
      amount_with_comma_separator: () => fmt(noDecimals ? 0 : 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => fmt(0, '.', ','),
      amount_with_apostrophe_separator: () => fmt(noDecimals ? 0 : 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => fmt(0, ' ', ','),
      amount_with_space_separator: () => fmt(noDecimals ? 0 : 2, ' ', ',')
    };
    const out = MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => (map[key] || map.amount_with_comma_separator)());
    return out.replace(/<[^>]*>/g, '');
  }
  const eur = (v, noDecimals) => money(Math.round((Number(v) || 0) * 100), noDecimals);
  const num = (v, d = 0) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }).format(v);
  const store = {
    get(k, d) { try { const v = localStorage.getItem('hs24-' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem('hs24-' + k, JSON.stringify(v)); } catch (e) { /* Speicher nicht verfügbar */ } }
  };
  const json = (url, opts = {}) => fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts))
    .then(async (r) => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.description || data.message || 'Das hat leider nicht geklappt.');
      return data;
    });

  /* ---------- Hinweis-Leiste ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { t.hidden = true; }, 3800);
  }

  /* ---------- Ebenen (Menü, Warenkorb, Filter) ---------- */
  let lastFocus = null;
  function openLayer(html, side) {
    closeLayer();
    lastFocus = document.activeElement;
    const layer = $('#layer'); if (!layer) return null;
    layer.innerHTML = '<div class="drawer-bg" data-close></div>' + html;
    const d = layer.querySelector('.drawer');
    if (d && side) d.classList.add(side);
    document.documentElement.style.overflow = 'hidden';
    const f = d && d.querySelector('button, a, input, summary');
    if (f) f.focus();
    return d;
  }
  function closeLayer() {
    const layer = $('#layer');
    if (!layer || !layer.innerHTML) return;
    layer.innerHTML = '';
    document.documentElement.style.overflow = '';
    const mb = $('#menu-open'); if (mb) mb.setAttribute('aria-expanded', 'false');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('#layer [data-close]')) closeLayer();
  });

  /* ---------- Mega-Menü ---------- */
  function initMega() {
    const btns = $$('[data-mega]');
    if (!btns.length) return;
    const closeAll = (except) => btns.forEach((b) => {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      const p = document.getElementById(b.dataset.mega); if (p) p.hidden = true;
    });
    const open = (b) => {
      closeAll(b);
      b.setAttribute('aria-expanded', 'true');
      const p = document.getElementById(b.dataset.mega); if (p) p.hidden = false;
    };
    const fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    let timer;
    btns.forEach((b) => {
      const p = document.getElementById(b.dataset.mega);
      b.addEventListener('click', () => (b.getAttribute('aria-expanded') === 'true' ? closeAll() : open(b)));
      if (fine) {
        const enter = () => { clearTimeout(timer); timer = setTimeout(() => open(b), 120); };
        const leave = () => { clearTimeout(timer); timer = setTimeout(() => closeAll(), 220); };
        b.addEventListener('mouseenter', enter); b.addEventListener('mouseleave', leave);
        if (p) { p.addEventListener('mouseenter', () => clearTimeout(timer)); p.addEventListener('mouseleave', leave); }
      }
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('.mainnav')) closeAll(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- Mobiles Menü ---------- */
  function initMobileNav() {
    const btn = $('#menu-open'); const tpl = $('#mnav-tpl');
    if (!btn || !tpl) return;
    btn.addEventListener('click', () => {
      openLayer(tpl.innerHTML, null);
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  /* ---------- Warenkorb ---------- */
  function setCount(n) {
    const b = $('#cart-count'); if (!b) return;
    b.textContent = n; b.dataset.n = n;
  }
  function cartHTML(cart) {
    const head = '<div class="drawer-head"><b>Warenkorb' + (cart.item_count ? ' (' + cart.item_count + ')' : '') + '</b><button class="icon-btn" type="button" data-close aria-label="Warenkorb schließen"><svg class="icon"><use href="#i-close"/></svg></button></div>';
    if (!cart.item_count) {
      return '<aside class="drawer right" aria-label="Warenkorb" role="dialog" aria-modal="true">' + head +
        '<div class="drawer-body"><div class="cart-empty"><b>Ihr Warenkorb ist leer</b><a class="btn btn-primary" href="' + esc(HS.routes.root) + 'collections">Produkte entdecken</a></div></div></aside>';
    }
    const items = cart.items.map((it, i) => {
      const img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="64" height="64">' : '';
      const variant = it.product_has_only_default_variant ? '' : '<div class="tax">' + esc(it.variant_title || '') + '</div>';
      return '<div class="ci" data-line="' + (i + 1) + '">' +
        '<a class="thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div style="min-width:0"><a class="t" href="' + esc(it.url) + '" style="text-decoration:none">' + esc(it.product_title) + '</a>' + variant +
        '<div class="controls"><div class="qty"><button type="button" data-cq="-1" aria-label="Menge verringern"><svg class="icon"><use href="#i-minus"/></svg></button>' +
        '<input value="' + it.quantity + '" inputmode="numeric" aria-label="Menge" data-cqi>' +
        '<button type="button" data-cq="1" aria-label="Menge erhöhen"><svg class="icon"><use href="#i-plus"/></svg></button></div>' +
        '<button class="icon-btn" type="button" data-cremove aria-label="' + esc(it.product_title) + ' entfernen"><svg class="icon"><use href="#i-trash"/></svg></button></div></div>' +
        '<div class="pr">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    return '<aside class="drawer right" aria-label="Warenkorb" role="dialog" aria-modal="true">' + head +
      '<div class="drawer-body"><div class="cart-items" style="padding-top:12px">' + items + '</div></div>' +
      '<div class="drawer-foot" style="display:grid;gap:10px">' +
      '<div class="sum-total"><b>Zwischensumme</b><span class="price tnum">' + money(cart.total_price) + '</span></div>' +
      '<span class="tax">Versandkosten werden an der Kasse berechnet.</span>' +
      '<form action="' + esc(HS.routes.cart) + '" method="post"><button class="btn btn-primary btn-block" type="submit" name="checkout"><svg class="icon"><use href="#i-shield"/></svg> Sicher zur Kasse</button></form>' +
      '<a class="btn btn-ghost btn-block" href="' + esc(HS.routes.cart) + '">Warenkorb ansehen</a></div></aside>';
  }
  function bindCartDrawer(d) {
    if (!d) return;
    const change = (line, quantity) => {
      d.setAttribute('aria-busy', 'true');
      json(HS.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ line, quantity }) })
        .then((cart) => { setCount(cart.item_count); renderCart(cart); })
        .catch((err) => { toast(err.message); d.removeAttribute('aria-busy'); });
    };
    d.addEventListener('click', (e) => {
      const row = e.target.closest('[data-line]'); if (!row) return;
      const line = Number(row.dataset.line);
      const input = row.querySelector('[data-cqi]');
      const q = e.target.closest('[data-cq]');
      if (q) change(line, Math.max(0, Number(input.value) + Number(q.dataset.cq)));
      if (e.target.closest('[data-cremove]')) change(line, 0);
    });
    d.addEventListener('change', (e) => {
      if (!e.target.matches('[data-cqi]')) return;
      const row = e.target.closest('[data-line]');
      const v = parseInt(e.target.value, 10);
      change(Number(row.dataset.line), Number.isFinite(v) && v >= 0 ? v : 1);
    });
  }
  function renderCart(cart) {
    const keepFocus = lastFocus;
    const d = openLayer(cartHTML(cart), null);
    lastFocus = keepFocus;
    bindCartDrawer(d);
  }
  function openCart() {
    return json(HS.routes.cart + '.js').then((cart) => { setCount(cart.item_count); renderCart(cart); })
      .catch(() => { window.location.href = HS.routes.cart; });
  }
  function addToCart(items, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return json(HS.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items }) })
      .then(() => openCart())
      .catch((err) => toast(err.message))
      .finally(() => { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }
  function initCart() {
    const open = $('#cart-open');
    if (open && !document.body.classList.contains('template-cart')) {
      open.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
    }
    document.addEventListener('click', (e) => {
      const q = e.target.closest('[data-quick-add]'); if (!q) return;
      e.preventDefault();
      addToCart([{ id: Number(q.dataset.quickAdd), quantity: 1 }], q);
    });
  }

  /* ---------- Produktseite ---------- */
  function initProduct() {
    const form = $('#pdp-form'); if (!form) return;
    const dataEl = $('[data-product-json]');
    let product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { product = null; }
    const idInput = form.querySelector('[data-variant-id]');
    const qty = form.querySelector('#pq');
    const addBtn = form.querySelector('[data-add-btn]');
    const sticky = $('[data-sticky-add]');

    form.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pq]'); if (!b) return;
      const v = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.pq));
      qty.value = v;
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const q = Math.max(1, parseInt(qty.value, 10) || 1);
      addToCart([{ id: Number(idInput.value), quantity: q }], addBtn);
    });
    if (sticky) sticky.addEventListener('click', () => (form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }))));

    const sel = form.querySelector('[data-variant-select]');
    const groups = form.querySelector('[data-option-groups]');
    const setButton = (text, enabled) => {
      [addBtn, sticky].forEach((b) => { if (b) b.disabled = !enabled; });
      if (addBtn) addBtn.lastChild.textContent = text;
    };
    // Eine Auswahl je Option: Kombination auflösen, nicht erhältliche Kombinationen kennzeichnen
    if (groups && sel && product && product.options && product.options.length) {
      groups.hidden = false;
      const fb = form.querySelector('[data-variant-fallback]'); if (fb) fb.hidden = true;
      const chosen = () => $$('input[type=radio]:checked', groups).sort((a, b) => a.dataset.optIndex - b.dataset.optIndex).map((i) => i.value);
      const markChips = () => {
        const cur = chosen();
        $$('input[type=radio]', groups).forEach((inp) => {
          const idx = Number(inp.dataset.optIndex);
          const test = cur.slice(); test[idx] = inp.value;
          const match = product.variants.find((x) => x.options.every((o, k) => o === test[k]));
          inp.closest('.opt-chip').classList.toggle('na', !match || !match.available);
        });
      };
      groups.addEventListener('change', () => {
        const cur = chosen();
        const v = product.variants.find((x) => x.options.every((o, k) => o === cur[k]));
        markChips();
        if (!v) { setButton('Diese Kombination gibt es nicht', false); return; }
        sel.value = String(v.id);
        sel.dispatchEvent(new Event('change'));
      });
      markChips();
    }
    if (sel && product) {
      sel.addEventListener('change', () => {
        const v = product.variants.find((x) => String(x.id) === sel.value); if (!v) return;
        if (idInput !== sel) idInput.value = v.id;
        $$('[data-price-wrap]').forEach((w) => {
          const p = w.querySelector('[data-price]'); if (p) p.textContent = money(v.price);
          let c = w.querySelector('[data-compare]');
          if (v.compare_at_price && v.compare_at_price > v.price) {
            if (!c) { c = document.createElement('s'); c.className = 'price-old'; c.dataset.compare = ''; p.after(c); }
            c.textContent = money(v.compare_at_price);
          } else if (c) { c.remove(); }
        });
        setButton(v.available ? ' In den Warenkorb' : 'Derzeit nicht verfügbar', v.available);
        if (v.featured_image && v.featured_image.src) setMainImage(v.featured_image.src);
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    function setMainImage(src) {
      const img = $('[data-gallery-main] img'); if (!img) return;
      img.removeAttribute('srcset'); img.src = src;
    }
    $$('.g-thumb').forEach((t, i) => {
      if (i === 0) t.setAttribute('aria-current', 'true');
      t.addEventListener('click', () => {
        $$('.g-thumb').forEach((x) => x.removeAttribute('aria-current'));
        t.setAttribute('aria-current', 'true');
        setMainImage(t.dataset.full);
      });
    });
  }

  /* ---------- Passende Produkte (Section Rendering API) ---------- */
  function initRecs() {
    $$('[data-recs]').forEach((el) => {
      if (el.children.length || !el.dataset.url) return;
      fetch(el.dataset.url).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(() => {});
    });
  }

  /* ---------- Suche mit Vorschlägen ---------- */
  function initSearch() {
    const input = $('#q'); const box = $('#suggest');
    if (!input || !box) return;
    let timer; let ctrl; let active = -1;
    const items = () => $$('.sg-item', box);
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const mark = (text, q) => {
      const safe = esc(text);
      const words = q.trim().split(/\s+/).filter((w) => w.length > 1).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (!words.length) return safe;
      return safe.replace(new RegExp('(' + words.map(esc).join('|') + ')', 'gi'), '<mark>$1</mark>');
    };
    const render = (res, q) => {
      const r = (res && res.resources && res.resources.results) || {};
      const prods = r.products || []; const cols = r.collections || []; const pages = (r.pages || []).concat(r.articles || []);
      let html = '';
      if (cols.length) html += '<h4>Kategorien</h4>' + cols.map((c) => '<a class="sg-item" role="option" href="' + esc(c.url) + '"><span class="t">' + mark(c.title, q) + '</span></a>').join('');
      if (prods.length) {
        html += '<h4>Produkte</h4>' + prods.map((p) => {
          const img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="" width="40" height="40">' : esc((p.vendor || '').slice(0, 3));
          const price = p.price ? eur(String(p.price).replace(',', '.')) : '';
          return '<a class="sg-item" role="option" href="' + esc(p.url) + '"><span class="thumb">' + img + '</span><span class="t">' + mark(p.title, q) + '</span><span class="p">' + price + '</span></a>';
        }).join('');
      }
      if (pages.length) html += '<h4>Ratgeber &amp; Seiten</h4>' + pages.map((p) => '<a class="sg-item" role="option" href="' + esc(p.url) + '"><span class="t">' + mark(p.title, q) + '</span></a>').join('');
      html += html ? '<a class="sg-item" role="option" href="' + esc(HS.routes.search) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last"><span class="t"><b>Alle Ergebnisse für „' + esc(q) + '“</b></span></a>'
        : '<div class="sg-empty">Keine Vorschläge. Mit Enter suchen Sie im ganzen Shop.</div>';
      box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
    };
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        const url = HS.routes.predictive + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then((r) => r.json()).then((res) => render(res, q)).catch(() => {});
      }, 180);
    });
    input.addEventListener('keydown', (e) => {
      const list = items(); if (box.hidden || !list.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
        list.forEach((x, i) => x.classList.toggle('active', i === active));
        list[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault(); window.location.href = list[active].href;
      } else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('#search-box')) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      const t = e.target;
      if (t.closest('input, textarea, select, [contenteditable="true"]')) return;
      e.preventDefault(); input.focus();
    });
  }

  /* ---------- Balkonkraftwerk-Konfigurator ---------- */
  function initConfigurators() {
    $$('[data-configurator]').forEach((root) => {
      let cfg;
      try { cfg = JSON.parse(root.querySelector('[data-cfg-json]').textContent); } catch (e) { return; }
      if (!cfg.devices || !cfg.devices.length) return;
      const devInputs = $$('input[name^="cfg-dev-"]', root);
      const mountInputs = $$('input[name^="cfg-mount-"]', root);
      const saved = store.get('cfg', {});
      const st = {
        dev: saved.dev && cfg.devices.some((d) => d.key === saved.dev) ? saved.dev : null,
        n: saved.n || 2,
        mount: saved.mount && (saved.mount === 'none' || cfg.mounts.some((m) => m.key === saved.mount)) ? saved.mount : 'none'
      };
      const firstEnabled = devInputs.find((i) => !i.disabled);
      if (!st.dev || (devInputs.find((i) => i.value === st.dev) || {}).disabled) st.dev = firstEnabled ? firstEnabled.value : cfg.devices[0].key;
      devInputs.forEach((i) => { i.checked = i.value === st.dev; });
      mountInputs.forEach((i) => { i.checked = i.value === st.mount; });
      const kwhNum = (k) => { const v = parseFloat(String(k || '').replace(',', '.')); return Number.isFinite(v) ? v : 0; };

      const calc = () => {
        const d = cfg.devices.find((x) => x.key === st.dev) || cfg.devices[0];
        const max = Math.max(1, Number(d.max) || 1);
        const n = Math.min(Math.max(1, st.n), max);
        const m = cfg.mounts.find((x) => x.key === st.mount);
        const mq = m ? (m.per === 'modul' ? n : 1) : 0;
        const lines = d.items.map((it) => ({ id: it.id, title: it.title, qty: 1, price: it.price }));
        lines.push({ id: cfg.module.id, title: cfg.module.title, qty: n, price: cfg.module.price });
        if (m && mq) lines.push({ id: m.id, title: m.label, qty: mq, price: m.price });
        const total = lines.reduce((a, l) => a + l.qty * l.price, 0);
        return { d, n, max, m, lines, total, wp: n * (Number(cfg.module.wp) || 0), kwh: kwhNum(d.kwh) };
      };
      const upd = () => {
        const r = calc();
        st.n = r.n;
        store.set('cfg', st);
        $('[data-cfg-n]', root).innerHTML = [1, 2, 3, 4].map((i) => '<button type="button" data-n="' + i + '" aria-pressed="' + (i === r.n) + '"' + (i > r.max ? ' disabled' : '') + '>' + i + '</button>').join('');
        $('[data-cfg-kv]', root).innerHTML =
          '<div><b>' + num(r.wp) + ' Wp</b><small>Modulleistung</small></div>' +
          '<div><b>' + (cfg.feedLimit ? num(cfg.feedLimit) + ' W' : '–') + '</b><small>Einspeisung</small></div>' +
          '<div><b>' + (r.kwh ? num(r.kwh, 2) + ' kWh' : '–') + '</b><small>Speicher</small></div>';
        $('[data-cfg-lines]', root).innerHTML = r.lines.map((l) => '<div class="sum-line"><span>' + l.qty + ' × ' + esc(l.title) + '</span><span>' + money(l.qty * l.price) + '</span></div>').join('');
        $('[data-cfg-total]', root).textContent = money(r.total);
        const add = $('[data-cfg-add]', root);
        if (add) add.disabled = !cfg.module.available;
        HS.lastCfg = { label: r.d.label, n: r.n, wp: r.wp, kwh: r.kwh, total: r.total / 100, moduleWp: cfg.module.wp };
        document.dispatchEvent(new CustomEvent('hs24:cfg', { detail: HS.lastCfg }));
      };
      root.addEventListener('change', (e) => {
        const n = e.target.name || '';
        if (n.indexOf('cfg-dev-') === 0) st.dev = e.target.value;
        if (n.indexOf('cfg-mount-') === 0) st.mount = e.target.value;
        upd();
      });
      root.addEventListener('click', (e) => {
        const b = e.target.closest('[data-n]');
        if (b && !b.disabled) { st.n = Number(b.dataset.n); upd(); }
        const add = e.target.closest('[data-cfg-add]');
        if (add) {
          const r = calc();
          addToCart(r.lines.map((l) => ({ id: Number(l.id), quantity: l.qty })), add);
        }
      });
      upd();
    });
  }

    /* ---------- Stromspar-Rechner ---------- */
  function initCalculators() {
    $$('[data-calc]').forEach((root) => {
      const ds = root.dataset;
      const F = { sued: Number(ds.factorSued) || 950, ow: Number(ds.factorOw) || 800, senk: Number(ds.factorSenk) || 650 };
      const L = { sued: 'Süd ' + num(F.sued), ow: 'Ost/West ' + num(F.ow), senk: 'senkrecht ' + num(F.senk) };
      const qPlain = (Number(ds.qPlain) || 35) / 100;
      const qStorage = (Number(ds.qStorage) || 70) / 100;
      const fallback = { label: 'Beispiel-Set', n: 0, wp: Number(ds.setWp) || 0, kwh: ds.setStorage === 'true' ? 1 : 0, total: Number(ds.setPrice) || 0, example: true };
      const use = $('[data-c-use]', root); const price = $('[data-c-price]', root); const orient = $('[data-c-orient]', root);
      const saved = store.get('calc', null);
      if (saved) { use.value = saved.use; price.value = saved.price; orient.value = saved.orient; }
      const set = (sel, v) => { const el = $(sel, root); if (el) el.textContent = v; };
 
      // Zeile „Anteil am Verbrauch" und Hinweis: werden angelegt, falls die Section sie nicht enthält
      const saveEl = $('[data-r-save]', root);
      let shareEl = $('[data-r-share]', root);
      if (!shareEl && saveEl) {
        shareEl = document.createElement('small');
        shareEl.dataset.rShare = '';
        shareEl.style.display = 'block';
        shareEl.style.marginTop = '4px';
        saveEl.after(shareEl);
      }
      let tipEl = $('[data-r-tip]', root);
      if (!tipEl && shareEl) {
        tipEl = document.createElement('small');
        tipEl.dataset.rTip = '';
        tipEl.style.display = 'block';
        tipEl.style.marginTop = '6px';
        tipEl.style.fontWeight = '600';
        shareEl.after(tipEl);
      }
 
      const update = () => {
        const s = HS.lastCfg || fallback;
        const u = Number(use.value); const pr = Number(price.value); const o = orient.value in F ? orient.value : 'sued';
        store.set('calc', { use: u, price: pr, orient: o });
        const y = s.wp / 1000 * F[o];
        const q = s.kwh ? qStorage : qPlain;
        const cap = u * 0.6;
        const self = Math.min(y * q, cap);
        const save = self * pr;
        const share = u > 0 ? self / u * 100 : 0;
        set('[data-o-use]', num(u) + ' kWh');
        set('[data-o-price]', num(pr, 2) + ' €/kWh');
        const setEl = $('[data-c-set]', root);
        if (setEl) {
          setEl.innerHTML = s.example
            ? 'Gerechnet mit einem Beispiel-Set: ' + num(s.wp) + ' Wp' + (s.kwh ? ' mit Speicher' : ' ohne Speicher') + ' · <b>' + eur(s.total) + '</b>.'
            : 'Gerechnet mit Ihrer Konfiguration: <b>' + esc(s.label) + '</b>, ' + s.n + ' × ' + num(s.moduleWp) + ' Wp' + (s.kwh ? ', ' + num(s.kwh, 2) + ' kWh Speicher' : ', ohne Speicher') + ' · <b>' + eur(s.total) + '</b>. <a href="#konfigurator" style="color:var(--link)">Ändern</a>';
        }
        set('[data-r-save]', eur(Math.round(save), true));
        if (shareEl) {
          shareEl.textContent = 'Sie nutzen ca. ' + num(Math.round(self)) + ' kWh selbst – das deckt ' + num(Math.round(share)) + ' % Ihres Verbrauchs von ' + num(u) + ' kWh.';
        }
        if (tipEl) {
          let tip = '';
          if (self >= cap - 0.5) {
            tip = 'Ihr Set liefert mehr, als Sie sinnvoll selbst nutzen können – ein kleineres Set würde reichen.';
          } else if (share < 15) {
            tip = s.kwh
              ? 'Ihr Verbrauch ist deutlich höher als der Ertrag: Weitere Module erhöhen Ihre Ersparnis.'
              : 'Ihr Verbrauch ist deutlich höher als der Ertrag: Mit einem Speicher oder weiteren Modulen sparen Sie mehr.';
          }
          tipEl.textContent = tip;
          tipEl.hidden = !tip;
        }
        set('[data-r-yield]', num(Math.round(y)) + ' kWh');
        set('[data-r-amort]', save > 0 ? 'ca. ' + num(s.total / save, 1) + ' J.' : '–');
        set('[data-r-20]', eur(Math.round(save * 20 - s.total), true));
        set('[data-r-ass]', L[o] + ' kWh je kWp, Eigenverbrauch ' + Math.round(q * 100) + ' % des Ertrags, höchstens 60 % Ihres Jahresverbrauchs');
      };
      root.addEventListener('input', update);
      root.addEventListener('change', update);
      document.addEventListener('hs24:cfg', update);
      update();
    });
  }
 
  /* ---------- Filter und Sortierung ---------- */
  function initFacets() {
    const form = $('[data-facets]'); if (!form) return;
    const panel = $('#filters');
    const submit = () => {
      $$('input', form).forEach((i) => { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') i.disabled = true; });
      form.submit();
    };
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) {
        const h = form.querySelector('[data-sort-hidden]'); if (h) h.value = e.target.value;
        submit(); return;
      }
      if (panel && panel.classList.contains('open')) return; // mobil: erst mit „Ergebnisse anzeigen“
      if (e.target.closest('#filters')) submit();
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    const sort = $('#sort-by');
    if (sort) sort.removeAttribute('name');
    const openBtn = $('#f-open');
    const closeF = () => { if (panel) panel.classList.remove('open'); document.documentElement.style.overflow = ''; const bg = $('.f-bg'); if (bg) bg.remove(); if (openBtn) openBtn.focus(); };
    if (openBtn && panel) {
      openBtn.addEventListener('click', () => {
        panel.classList.add('open'); document.documentElement.style.overflow = 'hidden';
        const bg = document.createElement('div'); bg.className = 'drawer-bg f-bg'; bg.addEventListener('click', closeF);
        panel.before(bg);
        const f = panel.querySelector('button, input'); if (f) f.focus();
      });
    }
    $$('[data-close-filters]').forEach((b) => b.addEventListener('click', closeF));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel && panel.classList.contains('open')) closeF(); });
  }
 
  /* ---------- WhatsApp-Beratung ---------- */
  function initWhatsApp() {
    const pop = $('#wa-pop'); const fab = $('#wa-open');
    if (!pop || !HS.whatsapp) return;
    const text = $('#wa-text'); const send = $('#wa-send');
    const base = text ? text.value.trim() : '';
    const sync = () => { if (send) send.href = 'https://wa.me/' + encodeURIComponent(HS.whatsapp) + '?text=' + encodeURIComponent(text ? text.value.trim() : ''); };
    const open = (product) => {
      if (text) text.value = product ? base + '\n\nEs geht um: ' + product : (text.value || base);
      sync();
      pop.hidden = false; if (fab) fab.setAttribute('aria-expanded', 'true');
      if (text) text.focus();
    };
    const close = () => { pop.hidden = true; if (fab) { fab.setAttribute('aria-expanded', 'false'); fab.focus(); } };
    if (fab) fab.addEventListener('click', () => (pop.hidden ? open() : close()));
    const x = $('#wa-close'); if (x) x.addEventListener('click', close);
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-wa]'); if (!b) return;
      e.preventDefault(); closeLayer(); open(b.dataset.waProduct || '');
    });
    const qs = $('#wa-q');
    if (qs) qs.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b || !text) return;
      text.value = (text.value.trim() ? text.value.trim() + '\n' : '') + b.textContent.trim(); sync(); text.focus();
    });
    if (text) text.addEventListener('input', sync);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) close(); });
    sync();
  }
 
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLayer(); });
 
  const init = () => {
    [initMega, initMobileNav, initCart, initProduct, initRecs, initSearch, initConfigurators, initCalculators, initFacets, initWhatsApp]
      .forEach((fn) => { try { fn(); } catch (err) { console.error('[HS24]', fn.name, err); } });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => { initConfigurators(); initCalculators(); });
  }
})();
 